import { render, staticRenderFns } from "./NewTicket.vue?vue&type=template&id=2fdef24c&scoped=true"
import script from "./NewTicket.vue?vue&type=script&lang=ts"
export * from "./NewTicket.vue?vue&type=script&lang=ts"
import style0 from "./NewTicket.vue?vue&type=style&index=0&id=2fdef24c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fdef24c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2fdef24c')) {
      api.createRecord('2fdef24c', component.options)
    } else {
      api.reload('2fdef24c', component.options)
    }
    module.hot.accept("./NewTicket.vue?vue&type=template&id=2fdef24c&scoped=true", function () {
      api.rerender('2fdef24c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/tickets/NewTicket.vue"
export default component.exports